import { useEffect, useState } from "react";
import "./DataTagLayout.scss";
import { useDispatch, useSelector } from "react-redux";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { cubejsApi } from "../../components/common/Dashboard/cubejs-util";
import { GET_NODES_LIST } from "../../redux/constants/constants";
import { cubeQueryGen } from "../../components/common/utilities";
import DataSourceDropdown from "./DataEstate/DataSourceDropDown";
import { FETCH_ALL_DATA_SOURCES_API_DATA_TAG } from "./DataTagConstants";

export default function DataTagLayout({ tabs }) {
  const dispatch = useDispatch();
  const dashboardLoader = useSelector((state) => state.dataTagReducer.loading);
  const summaryLoader = useSelector((state) => state.dataTagReducer.summaryLoader);
  const dataNodesDetails = useSelector(
    (state) => state.dataTagReducer.nodesData
  ); // array of nodes
  const allDataSources = useSelector(
    (state) => state.dataTagReducer.allDataSources
  );
  const [activeTab, setActiveTab] = useState(tabs?.[0]?.name);
  const ActiveComponent = tabs.find((tab) => tab.name === activeTab)?.component;
  const dimensionType = ["nodeId", "nodeName", "nodeType"];
  const queryString = cubeQueryGen("NodesOfApplication", dimensionType, []);

  useEffect(() => {
    if (activeTab === "Data Estate") {
      dispatch({
        type: GET_NODES_LIST,
        payload: {
          cubejsApi: cubejsApi,
          queryString: queryString,
        },
      });
      dispatch({
      type: FETCH_ALL_DATA_SOURCES_API_DATA_TAG,
      payload: {
        page: 0,
        size: 200,
      }
    })
    }
  }, [activeTab]);

  const loader = dashboardLoader || (activeTab === "Data Estate" && summaryLoader);

  return (
    <>
      {loader && (
        <img
          src={Page_Loader}
          alt="loading"
          className="loader-data-source dataTag"
        ></img>
      )}
      <div className="data-tag-layout">
        <h2 className="header-title">DataTag</h2>
        <div className="header-line"></div>

        <div className="data-estate-header-container">
          <div className="tab-toggle">
            {tabs.map((tab, index) => (
              <div key={tab.name} className="toggle-wrapper">
                <button
                  className={`toggle-item ${
                    activeTab === tab.name ? "active" : ""
                  }`}
                  onClick={() => setActiveTab(tab.name)}
                >
                  {tab.name}
                </button>
              </div>
            ))}
          </div>
          {activeTab === "Data Estate" && (
            <div>
              <DataSourceDropdown dataSourceDetails={allDataSources} dataNodes={dataNodesDetails}/>
            </div>
          )}
        </div>

        <div className="tab-content">{ActiveComponent}</div>
      </div>
    </>
  );
}
